import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const LINKS = [
  { to: '/admin', label: 'Users' },
  { to: '/admin/conversations', label: 'Conversations' },
];

export default function AdminNav() {
  const { pathname } = useLocation();

  return (
    <nav className="admin-nav">
      {LINKS.map((link) => (
        <Link
          key={link.to}
          to={link.to}
          className={pathname === link.to ? 'admin-nav-link admin-nav-link--active' : 'admin-nav-link'}
        >
          {link.label}
        </Link>
      ))}
    </nav>
  );
}
